import { toast } from 'sonner';
import { readPreference, writePreference } from './consent';

export async function copyText(text, msg = 'Copied!') {
  let copied = false;
  try {
    await navigator.clipboard.writeText(text);
    copied = true;
  } catch (e) {
    const focused = document.activeElement;
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
    document.body.appendChild(ta);
    ta.select();
    try { copied = document.execCommand('copy') === true; } catch (err) { /* Report failure below. */ }
    finally { ta.remove(); focused?.focus?.({ preventScroll: true }); }
  }
  if (copied) toast.success(msg);
  else {
    const errors = {
      en: 'Copy failed. Select the text and copy it manually.',
      fr: 'La copie a échoué. Sélectionnez le texte et copiez-le manuellement.',
      es: 'No se pudo copiar. Selecciona el texto y cópialo manualmente.',
      id: 'Gagal menyalin. Pilih teks dan salin secara manual.',
    };
    toast.error(errors[document.documentElement.lang] || errors.en);
  }
  return copied;
}

export function downloadFile(name, content, type = 'text/plain;charset=utf-8') {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export async function copyHtml(text) {
  const html = `<p style="font-size:18pt">${text.replace(/</g, '&lt;')}</p>`;
  try {
    const item = new ClipboardItem({ 'text/html': new Blob([html], { type: 'text/html' }), 'text/plain': new Blob([text], { type: 'text/plain' }) });
    await navigator.clipboard.write([item]);
    toast.success('Copied with formatting for MS Word');
    return true;
  } catch (e) {
    return copyText(text, 'Copied for MS Word');
  }
}

export async function shareText(text) {
  if (navigator.share) {
    try { await navigator.share({ title: 'Cursive Text', text }); return; } catch (e) { return; }
  }
  copyText(`${text}\n${window.location.href}`, 'Link copied to share');
}

export const HISTORY_KEY = 'ctg_history';
export function loadHistory(key = HISTORY_KEY) {
  const history = readPreference(key, []);
  return Array.isArray(history) ? history.filter((item) => item && typeof item.text === 'string') : [];
}
export function pushHistory(entry, key = HISTORY_KEY) {
  const list = [entry, ...loadHistory(key).filter((h) => h.text !== entry.text)].slice(0, 6);
  writePreference(key, list);
  return list;
}

export function textStats(t) {
  const trimmed = t.trim();
  return {
    chars: Array.from(t).length,
    words: trimmed ? trimmed.split(/\s+/).length : 0,
    sentences: trimmed ? (trimmed.match(/[^.!?]+[.!?]*/g) || []).filter((s) => s.trim()).length : 0,
    letters: (t.match(/\p{L}/gu) || []).length,
  };
}
